module.exports = __webpack_public_path__ + "static/media/img_mausoleo.af2eba09.jpg";